// s_order.shipmentstatus ("Shipment Delivery Status" reference) and
// s_order.invoicestatus ("Order Invoice Status" reference), returned by the
// aggregator salesHistory list as shipmentStatus / orderInvoiceStatus. Both are
// null until the order is fulfilled; an unknown code shows as-is.
const SHIPMENT_STATUS = {
  ND: { color: "#6b7280", label: "Not Delivered" },
  PD: { color: "#E99013", label: "Partial Delivery" },
  FD: { color: "#1F8A4C", label: "Full Delivery" },
};

const ORDER_INVOICE_STATUS = {
  NINV: { color: "#6b7280", label: "Not Invoiced" },
  PINV: { color: "#E99013", label: "Partially Invoiced" },
  INV: { color: "#1F8A4C", label: "Invoiced" },
  GI: { color: "#1F8A4C", label: "Generated" },
  NAPP: { color: "#6b7280", label: "Not Applicable" },
};

// Invoiced / Generated = bill done. Not Applicable belongs to neither bills tab.
const BILLED_INVOICE_STATUSES = ["INV", "GI"];

const statusDisplay = (map, code) => (code ? map[code] || { color: "#6b7280", label: code } : null);

export const getShipmentStatusDisplay = (code) => statusDisplay(SHIPMENT_STATUS, code);
export const getOrderInvoiceStatusDisplay = (code) => statusDisplay(ORDER_INVOICE_STATUS, code);
export const isBillCompleted = (order) => BILLED_INVOICE_STATUSES.includes(order?.orderInvoiceStatus);
export const isBillPending = (order) => !isBillCompleted(order) && order?.orderInvoiceStatus !== "NAPP";
